import { render, staticRenderFns } from "./address.vue?vue&type=template&id=35c13508"
import script from "./address.vue?vue&type=script&lang=ts"
export * from "./address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/vercel/path0/components/ui/input.vue').default,UiOutlineButton: require('/vercel/path0/components/ui/outline-button.vue').default,UiIconClose: require('/vercel/path0/components/ui/icon/close.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default,FilterBaseFilterCard: require('/vercel/path0/components/filter/base-filter-card.vue').default})
